import { distance, midpoint, bearing, destination, lineArc, lineDistance } from "@turf/turf";
import { toWgs84, toMercator } from "@turf/projection";
import { ICoordinate } from "shared/types";

export const getCurvedLine = ({ start, end }: { start: ICoordinate; end: ICoordinate }) => {
  let route = {
    type: "LineString",
    coordinates: [
      [start.longitude, start.latitude],
      [end.longitude, end.latitude],
    ],
  };

  // convert to wgs84
  route = toWgs84(route);

  // @ts-ignore
  const dist = lineDistance(route, { units: "kilometers" });
  const mid = midpoint(route.coordinates[0], route.coordinates[1]);
  const center = destination(mid, dist, bearing(route.coordinates[0], route.coordinates[1]) - 90);
  const line = lineArc(
    center,
    distance(center, route.coordinates[0]),
    bearing(center, route.coordinates[1]),
    bearing(center, route.coordinates[0]),
    { steps: 128 }
  );

  // convert back to mercator
  return toMercator(line);
};
